import Vue from 'vue'
import LocationService from '@/services/location/'
import {
  LocationTypeName,
  Location,
} from '@/interfaces/valuation/types/LocalityValuationStep'
import { AddressCMService } from '@/services/location/addressCM'
import { HouseNumberCMService } from '@/services/location/houseNumberCM'
import { ProjectCMService } from '@/services/location/projectCM'
import { IdValueObject, ValidatedResponse } from '@/interfaces/app/ValueObjects'

export interface AutocompleteObject {
  id: undefined | number
  search: string
  items: IdValueObject[]
  loading: boolean
}

export interface AutocompleteObjectStreet {
  id: string
  search: string
  items: string[]
  loading: boolean
}

export default Vue.extend({
  name: '',
  computed: {
    locationService():
      | {}
      | AddressCMService
      | HouseNumberCMService
      | ProjectCMService {
      const name = this.$options.name!.replace(
        '-picker',
        ''
      ) as LocationTypeName
      return Object.keys(LocationService).includes(name)
        ? LocationService[name]
        : {}
    },
  },
  methods: {
    setLocation(location: Location | undefined) {
      this.$emit('setLocation', location)
    },
  },
  watch: {
    location(val: ValidatedResponse<Location>) {
      if (val.valid) {
        this.setLocation(val.value)
      } else {
        this.setLocation(undefined)
      }
    },
  },
})
